import axios from "axios";
import { getCookie } from "../getcookie.js";

const apiUrl = process.env.REACT_APP_API_URL;
const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL;

const header = {
    'Content-Type': 'application/json; charset=UTF-8',
    "Accept": "application/json",
    "Access-Control-Allow-Origin": "*", // Required for CORS support to work
    "Authorization": getCookie("mawalog")
}


export const exportdata = async (data, apivalue) => {
    try {
        const response = await axios.post(
            apiUrl + apivalue + `/report`, data, { headers: header }).then((response) => {
                return response;
            }).catch((error) => {
                console.log('error...', error.response)
                return error.response;

            });
        return response;
    } catch (err) {
        console.error("Error fetching category:", err);
    } finally {
    }
};
export const savetempalteApi = async (data) => {
    try {
        const response = await axios.post(
            adminApiUrl + `export_template`, data, { headers: header }).then((response) => {
                return response;
            }).catch((error) => {
                console.log('error...', error.response)
                return error.response;

            });
        return response;
    } catch (err) {
        console.error("Error fetching category:", err);
    } finally {
    }
};
export const exportquickApi = async (apivalue) => {
    try {
        const response = await axios.get(
            apiUrl + "report/" + apivalue, { headers: header }).then((response) => {
                return response;
            }).catch((error) => {
                console.log('error...', error.response)
                return error.response;

            });
        return response;
    } catch (err) {
        console.error("Error fetching category:", err);
    } finally {
    }
};


export const getquickreportApi = async () => {
    try {
        const response = await axios.get(
            apiUrl + `report/get_quick_report`,
            {
                headers: header,
            }
        );
        return response.data;
    } catch (err) {
        console.error("Error fetching category:", err);
    } finally {
    }
};
export const getTempalteApi = async () => {
    try {
        const response = await axios.get(
            adminApiUrl + `export_template?application=Gate`,
            {
                headers: header,
            }
        );
        return response.data;
    } catch (err) {
        console.error("Error fetching category:", err);
    } finally {
    }
};
export const getDownloadReportApi = async () => {
    try {
        const response = await axios.get(
            adminApiUrl + `downloaded_reports?type=Gate`,
            {
                headers: header,
            }
        );
        return response.data;
    } catch (err) {
        console.error("Error fetching category:", err);
    } finally {
    }
};
export const getExportfieldApis = async (id) => {
    try {
        const response = await axios.get(
            adminApiUrl + `export_template/` + id,
            {
                headers: header,
            }
        );
        return response.data;
    } catch (err) {
        console.error("Error fetching category:", err);
    } finally {
    }
};
export const getExportdownloadApis = async (id) => {
    try {
        const response = await axios.get(
            adminApiUrl + `downloaded_reports/` + id,
            {
                headers: header,
            }
        );
        return response.data;
    } catch (err) {
        console.error("Error fetching category:", err);
    } finally {
    }
};


export const downloadBase64File = (base64String, fileName) => {
    const binary = atob(base64String);
    const array = [];

    for (let i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i));
    }

    const blob = new Blob([new Uint8Array(array)], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
